import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './Banner.scss';

import R4Image from '../../assets/Hardware/r4.png';
import IdeImage from '../../assets/Software/ide2.png';
import PLCImage from '../../assets/Software/PLCide.png';
import classnames from 'classnames';

interface BannerProps {
  title: string;
  description: string;
  label?: string;
  image?: any | IGatsbyImageData | string;
  svg?: boolean;
  bottom?: boolean;
  reverse?: boolean;
  cta?: {
    url: string;
    label: string;
    icon?: React.ReactElement;
    external?: boolean;
  }[];
}

const getStaticImage = (img) => {
  switch (img) {
    case 'board':
      return <img src={R4Image} alt="Welcome" className="grid-card__image--item boards" />;
    case 'ide':
      return <img src={IdeImage} alt="Welcome" className="grid-card__image--item boards" />;
    case 'PLCide':
      return <img src={PLCImage} alt="Welcome" className="grid-card__image--item boards" />;
    default:
      break;
  }
};

export default function Banner({ title, description, image, cta, label, bottom, reverse }: BannerProps): React.ReactElement {
  return (
    <section className={classnames('banner', { banner__reverse: reverse })}>
      <div className="banner__text-container">
        {label && <div className="banner__label">{label}</div>}
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="banner__buttons-container">
          {cta &&
            cta.map((item) => (
              <a href={item.url} className="banner__cta" key={item.label} target={item.external ? '_blank' : null} rel="noreferrer">
                {item.label} {item.icon ? item.icon : null}
              </a>
            ))}
        </div>
      </div>
      <div className="banner__image-container">
        {image && image.extension === 'svg' && (
          // svg support
          <img src={image.publicURL} alt={'Featured'} className={classnames({ 'banner__image-container--bottom': bottom })} />
        )}
        {typeof image === 'string' ? (
          <img src={image} alt={title} />
        ) : !image.extension ? (
          <GatsbyImage alt={title} objectFit="cover" imgStyle={{ objectFit: 'cover' }} image={getImage(image)} />
        ) : null}
        {image && getStaticImage(image)}
      </div>
    </section>
  );
}
